import React, { useState, useEffect, useCallback } from 'react';
import Scrollspy from 'react-scrollspy';
import { toc, tocList, isCurrent, container } from './Toc.module.scss';
import headingToc from './HeadingToc';

export default function Toc({ item, tabs }) {
  const [data, setData] = useState([]);
  const [scrollTop, setScrollTop] = useState(false);
  const [url, setUrl] = useState([]);
  const [positionTop, setPositionTop] = useState(0);

  useEffect(() => {
    let total = 0;
    if (tabs) {
      total = 60;
    } else {
      total = 0;
    }
    setPositionTop(total);
  }, [tabs, setPositionTop]);

  const onScroll = useCallback(
    (e) => {
      let scroller = e.target.documentElement.scrollTop > 550;
      setScrollTop(scroller !== scrollTop ? scroller : scrollTop);
    },
    [setScrollTop, scrollTop]
  );

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    let datas = headingToc(item);

    if (datas.length > 0) {
      setUrl(datas.map((post) => post['url'].replace(/\s+/g, '-').toLowerCase()));
      setData(datas);
      let dataArraykey = [];
      let dataArray = [];
      datas.map((post) => {
        dataArraykey.push(post['url'].replace(/\s+/g, '-').toLowerCase());
        post.subMenus?.map((res) => dataArraykey.push(res['url'].replace(/\s+/g, '-').toLowerCase()));
        dataArray.push(post);
        post.subMenus?.map((res) =>
          dataArray.push({ ...res, url: res['url'].replace(/\s+/g, '-').toLowerCase(), subMenu: true })
        );
        return post;
      });
      setUrl(dataArraykey);
      setData(dataArray);
    }
  }, [item, onScroll]);

  const ComponentToc = useCallback(() => {
    return (
      <>
        <nav className={toc} style={{ position: scrollTop ? 'fixed' : 'block', top: positionTop }}>
          <Scrollspy items={url} currentClassName={isCurrent} className={tocList}>
            {data.map((value) => (
              <li key={value.url} style={{ fontSize: value?.subMenu ? 13 : 14 }}>
                <a
                  style={{ paddingLeft: value?.subMenu ? 32 : 20 }}
                  href={`#${value.url.replace(/\s+/g, '-').toLowerCase()}`}
                >
                  {value.title.length > 15 ? value.title.slice(0, 15) + '...' : value.title}
                </a>
              </li>
            ))}
          </Scrollspy>
        </nav>
      </>
    );
  }, [scrollTop, data, url, positionTop]);

  return (
    <div className={container}>
      <ComponentToc />
    </div>
  );
}
